interface CharCounterProps {
  value?: string | null;
  max: number;
}

export function CharCounter({ value, max }: CharCounterProps) {
  const len = value?.length ?? 0;
  const isOver = len > max;
  const isWarning = !isOver && len > max * 0.85;

  return (
    <p
      className={`text-xs text-right tabular-nums select-none ${
        isOver
          ? 'text-destructive font-semibold'
          : isWarning
          ? 'text-amber-500'
          : 'text-muted-foreground'
      }`}
    >
      {len}/{max}
    </p>
  );
}

export function AtLimit({ value, max }: CharCounterProps) {
  if ((value?.length ?? 0) < max) return null;
  return (
    <p className="text-xs text-amber-500 font-medium">
      Límite de {max} caracteres alcanzado
    </p>
  );
}
